import axios from "axios";

/**
 * @param {Blob} blob
 * @param {string} fileName
 */
export const saveAs = (blob, fileName) => {
  const anchor = document.createElementNS("http://www.w3.org/1999/xhtml", "a");

  anchor.rel = "noopener";

  if (typeof blob === "string") {
    axios
      .get(blob, { responseType: "blob" })
      .then(response => {
        anchor.href = URL.createObjectURL(response.data);
        anchor.setAttribute("download", fileName);
        anchor.click();
        URL.revokeObjectURL(anchor.href);
      })
      .catch(error => console.error("Error:", error));
  } else {
    anchor.href = URL.createObjectURL(blob);
    anchor.download = fileName;
    setTimeout(() => URL.revokeObjectURL(anchor.href), 40 * 1000);
    setTimeout(() => anchor.click(), 0);
  }
};
